import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-map-radius",
  "use": "fi-icon-custom-map-radius-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"fi-icon-custom-map-radius\">\n    <circle cx=\"50\" cy=\"50\" r=\"40\" stroke=\"blue\" stroke-width=\"2\" fill=\"transparent\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol